import React from 'react';

import styles from './WithLoader.module.scss';
import { useTranslation } from '../../hooks/useTranslations';

interface Props {
  isLoading: boolean;
  children: React.ReactNode | Function;
}

const WithLoader = React.memo<any>(({ isLoading, children }: Props) => {
  const { translations } = useTranslation();
  if (isLoading)
    return (
      <div className={styles.container}>
        <div className={styles.loader} />
        <p className={styles.loadingText}>{translations('label.loading')}</p>
      </div>
    );

  if (!children) return null;

  return typeof children === 'function' ? children() : children;
});

export default WithLoader;
